import React, { useState, useEffect, useRef, useCallback } from 'react';

interface TooltipProps {
  content: string;
  children: React.ReactElement;
  tooltipStyle?: React.CSSProperties;
  arrowStyle?: React.CSSProperties;
  top?:number
}

export const Tooltip: React.FC<TooltipProps> = ({ content, children, tooltipStyle = {}, arrowStyle = {}, top }) => {
  const [showTooltip, setShowTooltip] = useState(false);
  const [tooltipPosition, setTooltipPosition] = useState({ left: 0, top: 0 });
  const tooltipRef = useRef<HTMLSpanElement>(null);
  const childRef = useRef<HTMLDivElement>(null);
  const hideTooltip = useCallback(() => {
    setShowTooltip(false);
  }, []);

  useEffect(() => {
    const handleScroll = () => {
      hideTooltip();
    };
    window.addEventListener('scroll', handleScroll, true);
    return () => {
      window.removeEventListener('scroll', handleScroll, true);
    };
  }, [hideTooltip]);

  const handleMouseEnter = () => {
    if (childRef.current) {
      const rect = childRef.current.getBoundingClientRect();
      setTooltipPosition({
        left: rect.left + rect.width / 2,
        top: rect.top
      });
    }
    setShowTooltip(true);
  };

  const handleMouseLeave = () => {
    setShowTooltip(false);
  };
  const topPosition = top ? top : 25
  const defaultTooltipStyle: React.CSSProperties = {
    position: 'fixed',
    left: tooltipPosition.left - 148,
    top: tooltipPosition.top - topPosition,
    transform: 'translateX(-50%)',
    backgroundColor: '#1f427b',
    color: 'white',
    padding: '5px 10px',
    borderRadius: '4px',
    fontSize: '14px',
    whiteSpace: 'normal',
    opacity: showTooltip ? 1 : 0,
    transition: 'opacity 0.15s, visibility 0.15s',
    pointerEvents: 'none',
    width: "210px",
    height: "auto",
    textAlign: "justify",
    fontSizeAdjust: "13px",
    lineHeight: "normal",
    wordSpacing: "2px",
    letterSpacing: "-1px",
    ...tooltipStyle
  };

  const defaultArrowStyle: React.CSSProperties = {
    position: 'absolute',
    top: '50%',
    right: '-4px',
    transform: 'translateY(-50%) rotate(45deg)',
    width: '10px',
    height: '10px',
    backgroundColor: '#1f427b',
    ...arrowStyle
  };

  return (
    <div
      ref={childRef}
      onMouseEnter={handleMouseEnter}
      onMouseLeave={handleMouseLeave}
      style={{ position: 'relative' }}
    >
      {children}
      <span ref={tooltipRef} style={defaultTooltipStyle}>
        {content}
        <span style={defaultArrowStyle} />
      </span>
    </div>
  );
};